import gql from 'graphql-tag';
import { getSingleProp } from 'src/utils/lib/graphql';
import apolloClient from 'src/store/client';
import { BRIEF_DEBUG_DATA_VISIBLE } from 'src/lib/featureFlags';

const MUTATION = gql`
  mutation GetScoreForDocumentEditor(
    $text: String!
    $projectId: ID!
    $generationTool: GenerationToolEnum!
  ) {
    getScoreForDocumentEditor(
      text: $text
      projectId: $projectId
      generationTool: $generationTool
    ) {
      id
      assetType
      text
      score
      lastUpdateTime
      ageScoreHistogram
      genderScoreHistogram
    }
  }
`;

const prepareContext = (projectId, generationTool, params) => {
  if (!BRIEF_DEBUG_DATA_VISIBLE) {
    return null;
  }

  const title = `"document get score" request [projectId: ${projectId}, generationTool: ${generationTool}, params: ${JSON.stringify(
    params
  )}]`;
  return { traceAuthorComplete: true, traceAuthorCompleteTitle: title };
};

export const getScoreForDocumentEditor = async ({
  text,
  projectId,
  generationTool,
}) => {
  const variables = {
    text,
    projectId,
    generationTool,
  };

  const response = await apolloClient.mutate({
    mutation: MUTATION,
    variables,
    context: prepareContext(projectId, generationTool, variables),
  });
  return getSingleProp(response.data);
};
